export function bridge(url) {
    let iframe = document.createElement('IFRAME')
    console.log(url, 'url')
    iframe.setAttribute('src', url)
    document.documentElement.appendChild(iframe)
    iframe.parentNode.removeChild(iframe)
    iframe = null
}

export const version = ()=> {
    let u = navigator.userAgent
    return {
        trident: u.indexOf('Trident') > -1, //IE内核
        presto: u.indexOf('Presto') > -1, //opera内核
        webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,//火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
        iPhone: u.indexOf('iPhone') > -1 , //是否为iPhone或者QQHD浏览器
        iPad: u.indexOf('iPad') > -1, //是否iPad
        webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
        weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
        qq: u.match(/\sQQ/i) == " qq" //是否QQ
    };
}

/**
 * 获取url参数
 * @param key 可选
 * @param url 可选
 */
export const getUrlParams = (key, url) => {
    url = url || window.location.href;
    const params = {};
    url.replace(/([^?&]+)=([^?&]+)/g, (s, v, k) => {
        params[decodeURIComponent(v)] = decodeURIComponent(k);
        return k + '=' + v;
    });
    return (key ? params[key] : params) || '';
};

/**
 * 空对象验证
 * @param obj
 * @returns {boolean}
 */
export const isEmptyObject = (obj) => {
    if (!obj) return true;
    let t;
    for (t in obj) return false;
    return true;
};

/**
 * 去除左右空格
 */
export const trim = (str) => {
    if (!str || typeof str !== 'string') return str;
    return str.replace(/^\s+|\s+$/g, '');
};

/**
 * 判断是否数字
 */
export const isNumber = (args) => /^[0-9]*$/.test(trim(args));

/**
 * 空判断
 * @param args
 * @return {boolean}
 */
export const isEmpty = (args) => args === null || args === undefined || args === '';

/**
 * 转换为number
 */
export const toNumber = (num) => {
    if (typeof num === 'number') return num;
    if (num && /^[0-9].*$/.test(num)) {
        return Number(num);
    }
    return null;
};


/**
 * 二进制文件转base64
 * @param blob    二进制文件
 */
export const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = (e) => reject(e.target.result);
        reader.readAsDataURL(blob);
    });
};

/**
 * 将base64转换为文件
 * @param base64     base64字符串
 * @param type       mime类型
 */
export const base64ToBlob = (base64, type) => {
    const arr = base64.split(',');
    const mime = arr[0].match(/:(.*?);/)[1] || type;
    // 去掉url的头，并转化为byte
    const bytes = window.atob(arr[1]);
    // 处理异常,将ascii码小于0的转换为大于0
    const ab = new ArrayBuffer(bytes.length);
    // 生成视图（直接针对内存）：8位无符号整数，长度1个字节
    const ia = new Uint8Array(ab);
    for (let i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
    }
    return new Blob([ab], { type: mime });
};

/**
 * 获取自定义id
 * @param count
 * @returns {string}
 */
export const getCustomId = (count) => {
    count = count || 6;
    let id = '';
    for (let i = 0; i < count; i++) {
        id += (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return id;
};

/**
 * 防抖函数 (如果一个函数持续地触发，那么只在它结束后过一段时间只执行一次)
 * @param func 传入函数
 * @param wait 表示时间窗口的间隔
 * @param immediate 是否立即触发
 * @return {Function}
 */
export const debounce = (func, wait, immediate) => {
    let timeout;
    return function () {
        /*eslint no-invalid-this: "off"*/
        const self = this;
        // 参数转为数组
        let args = Array.prototype.slice.call(arguments);
        return new Promise(function (resolve) { // 返回一个promise对象
            if (timeout) {
                clearTimeout(timeout);
            }
            if (immediate) {
                const callNow = !timeout;
                timeout = setTimeout(function () {
                    timeout = null;
                }, wait);
                if (callNow) {
                    resolve(func.apply(self, args)); //值操作
                }
            } else {
                timeout = setTimeout(function () {
                    resolve(func.apply(self, args));
                }, wait);
            }
        });
    };
};

/**
 * 节流函数 (如果一个函数持续的，频繁地触发，那么让它在一定的时间间隔后再触发)
 * @param func 传入函数
 * @param wait 表示时间窗口的间隔
 * @return {Function}
 */
export const throttle = (func, wait) => {
    let timeout;
    return function () {
        const context = this;
        const args = arguments;
        if (!timeout) {
            timeout = setTimeout(function () {
                func.apply(context, args);
                timeout = null;
            }, wait);
        }
    };
};

/**
 * 对象合并
 */
export const extend = (source, target, exclude = []) => {
    for (const prop in source) {
        if (Object.prototype.hasOwnProperty.call(source, prop)
            && Object.prototype.hasOwnProperty.call(target, prop)
            && !exclude.includes(prop)) {
            source[prop] = target[prop];
        }
    }
    return source;
};

/**
 * 将当前时间换成时间格式字符串
 * @param time      时间戳
 * @param format    格式
 * @param options   可选项
 * @param options.firstDayOfMonth   获取当月第一天
 * @param options.firstDayOfSeason  获取当季第一天
 * @param options.firstDayOfYear    获取当年第一天
 * @returns {string}
 *
 * 将 Date 转化为指定格式的String * 月(M)、日(d)、12小时(h)、24小时(H)、分(m)、秒(s)、周(E)、季度(q)
 * 可以用 1-2 个占位符 * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 * eg:
 *    (Common.formatDate(new Date(), "yyyy-MM-dd hh:mm:ss.S") ==> 2018-07-02 08:09:04.423
 *    (Common.formatDate(new Date(), "yyyy-MM-dd E HH:mm:ss") ==> 2018-03-10 二 20:09:04
 *    (Common.formatDate(new Date(), "yyyy-MM-dd EE hh:mm:ss") ==> 2018-03-10 周二 08:09:04
 *    (Common.formatDate(new Date(), "yyyy-MM-dd EEE hh:mm:ss") ==> 2018-03-10 星期二 08:09:04
 *    (Common.formatDate(new Date(), "yyyy-M-d h:m:s.S") ==> 2018-7-2 8:9:4.18
 */
export const formatDate = (time, format = 'yyyy-MM-dd', options) => {
    time = time || new Date();
    let date;
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(time)) {
        date = new Date(time);
    } else if (/^[0-9]*$/.test(time)) {
        date = new Date(Number(time));
    } else if (typeof time === 'string' && time.includes(' ') && time.includes('-')) {
        date = new Date(time.replace(/-/g, '/'));
    } else if (typeof time === 'string' && (time.includes('年') || time.includes('月') || time.includes('日'))) {
        date = new Date(time.replace(/[年月日]/g, '/'));
    } else {
        date = new Date(time);
    }
    if (options) {
        // 获取当月第一天
        if (options.firstDayOfMonth) {
            return date.setDate(1) && formatDate(date, format);
        }
        // 获取当季第一天
        if (options.firstDayOfSeason) {
            const month = date.getMonth();
            if (month < 3) {
                date.setMonth(0);
            } else if (month > 2 && month < 6) {
                date.setMonth(3);
            } else if (month > 5 && month < 9) {
                date.setMonth(6);
            } else if (month > 8 && month < 11) {
                date.setMonth(9);
            }
            date.setDate(1);
            return formatDate(date, format);
        }
        // 获取当年第一天
        if (options.firstDayOfYear) {
            return date.setDate(1) && date.setMonth(0) && formatDate(date, format);
        }
        // 获取本周第一天
        if (options.firstWeekOfDay) {
            let weekday = date.getDay() || 7; //获取星期几,getDay()返回值是 0（周日） 到 6（周六） 之间的一个整数。0||7为7，即weekday的值为1-7
            date.setDate(date.getDate() - weekday + 1);//往前算（weekday-1）天，年份、月份会自动变化
            return formatDate(date, format);
        }
    }
    const dateObj = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), 		// 日
        'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12, // 小时
        'H+': date.getHours(), 	// 小时
        'm+': date.getMinutes(), 	// 分
        's+': date.getSeconds(), 	// 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        'S+': date.getMilliseconds() // 毫秒
    };
    const week = {
        0: '\u65e5',
        1: '\u4e00',
        2: '\u4e8c',
        3: '\u4e09',
        4: '\u56db',
        5: '\u4e94',
        6: '\u516d'
    };
    if (/(y+)/i.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    if (/(E+)/.test(format)) {
        format = format.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? '\u661f\u671f' : '\u5468') : '') + week[date.getDay() + '']);
    }
    for (const k in dateObj) {
        if (Object.prototype.hasOwnProperty.call(dateObj, k)
            && new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? dateObj[k] : ('00' + dateObj[k]).substr(('' + dateObj[k]).length));
        }
    }
    return format;
};

/**
 * 对象深拷贝
 */
export const deepCopy = (obj) => {
    if (obj === null) return null;
    let result;
    // 判断是否是简单数据类型
    if (typeof obj === 'object') {
        // 复杂数据类型
        result = obj.constructor === Array ? [] : {};
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj,key)) {
                result[key] = typeof obj[key] === 'object' ? deepCopy(obj[key]) : obj[key];
            }
        }
    } else {
        // 简单数据类型,直接赋值
        result = obj;
    }
    return result;
};

/**
 * 优雅的处理 async/await
 * @param asyncFunc
 * @return {Promise<*[]>}
 */
export const errorCaptured = async (asyncFunc) => {
    try {
        const res = asyncFunc instanceof Promise ? await asyncFunc : await asyncFunc();
        return [null, res];
    } catch (e) {
        return [e, null];
    }
};


/**
 * 判断是否为base64字符串
 * @param {String} str
 */
export const isBase64 = (str) => {
    const base64Pattern = '^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$';
    if (/^data:image/.test(str)) return true;
    return !!str.match(base64Pattern);
};

/**
 * 获取时间戳
 * @returns {number}
 */
export const getTimeStamp = ()=> {
    return  new Date().getTime()
}

/**
 * 获取临时token
 */
export const getTemToken = ()=> {
    return "L"+ getTimeStamp() + getRandomString()
}

/**
 * 获取6位随机数
 * @returns {number}
 */
export const getRandomString = ()=> {
    let mm=Math.random();
    let six = null;
    if(mm>0.1)
    {
        six= Math.round(mm*1000000);
    }else{
        mm += 0.1;
        six = Math.round(mm*1000000);
    }
    return six;
}

export const  isIPhoneX =()=>{
    let isIPhoneX=false
    var u = navigator.userAgent;
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isIOS) {
        if (screen.height >= 812 && screen.width >= 375){
            isIPhoneX=true
            //是iphoneX
        }else{
            isIPhoneX=false
            //不是iphoneX
        }
    }
    return isIPhoneX
}

export function isIOS (){
  const u = navigator.userAgent
  const isIOS  = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  return isIOS 
}

export function isAndriod (){
  const u = navigator.userAgent
  const isAndroid  = u.indexOf('Android')>-1 || u.indexOf('Adr') > -1
  return isAndroid 
}

// 是否是小程序
export function isMini() {
  var userAgent = navigator.userAgent.toLowerCase()
  // 是否是微信小程序
  return /miniProgram/i.test(userAgent)
}

//过滤表情
export const checkEmojiRule = value => {
    const emojiRule = /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g;
    const flag = emojiRule.test(value);
    return flag;
  };

// 删除url参数
export const deleteUrlParam = (paramKey) => {
    var url = window.location.href;    //页面url
    var urlParam = window.location.search.substr(1);   //页面参数
    var beforeUrl = url.substr(0, url.indexOf("?"));   //页面主地址（参数之前地址）
    var nextUrl = "";
    var arr = new Array();
    if (urlParam != "") {
        var urlParamArr = urlParam.split("&"); //将参数按照&符分成数组
        for (var i = 0; i < urlParamArr.length; i++) {
            var paramArr = urlParamArr[i].split("="); //将参数键，值拆开
            //如果键雨要删除的不一致，则加入到参数中
            if (paramArr[0] != paramKey) {
                arr.push(urlParamArr[i]);
            }
        }
    }
    if (arr.length > 0) {
        nextUrl = "?" + arr.join("&");
    }
    url = beforeUrl + nextUrl;
    console.log('返回新的地址', url)
    return url;
}

